// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import type { Paths } from '@shared/data-access/interfaces/routes/paths';
import { useAppSelector } from '@advisor-app/store/store';
import { selectCurrentPortfolio } from '@shared/data-access/slices/portfolio-positions';

const pagesThatNeedPortfolioLoaded: Paths[] = [
  '/rebalance/configuration',
  '/rebalance/summary',
  '/tax-manager/etf/summary',
  '/tax-manager/stock/summary',
];

export const requiresPortfolioLoaded = (pathname: string): boolean => {
  if (pathname.endsWith('/positions')) {
    return true;
  }

  return pagesThatNeedPortfolioLoaded.includes(pathname as Paths);
};

export const useValidationPortfolioLoaded = () => {
  const holdings = useAppSelector(selectCurrentPortfolio);

  const isPortfolioLoaded = holdings.length > 0;

  return { isPortfolioLoaded, requiresPortfolioLoaded };
};
